import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../../config';
import { apiCode, apiConfig, apiFetch } from '../../../services';
import { setVideoTime } from '../../../actions/ui';
import { extension, fileIcon, assetLink } from '../assets';

export const FileLink = ({ file, folder, onLoaded, useVideoPosition }) => {
    const dispatch = useDispatch();
    const player = React.useRef(null);
    const user = useSelector(state => state.user.user);
    const videoPosition = useSelector(state => state.ui.videoPosition);

    React.useEffect(() => {
        const playVideo = async time => {
            try {
                player.current.currentTime = time;
                if (player.current.paused) {
                    await player.current.play();
                }
            } catch (err) {
                console.error(err);
            }
        };

        if (useVideoPosition && videoPosition && player.current) {
            playVideo(videoPosition);
        }
    }, [videoPosition, player.current]);

    if (!file) return null;

    const open = () => {
        apiFetch(`${config.apiGateway.URL}download-file/${folder}/${file.path}${apiCode()}`, apiConfig(user.guid, null, true))
            .then(response => {
                const blob = response.blob(file.name);
                blob.type = response.headers['content-type'];
                blob.filename = file.name; // doesn't work!
                return blob;
            })
            .then(blob => {
                const newWindow = window.open('/loading');
                URL.createObjectURL(blob);
                newWindow.onload = () => {
                    newWindow.location = URL.createObjectURL(blob);
                };
            })
            .catch(err => {
                // console.log(err);
            });
    };

    const fileSize = size => {
        if (size < 1024) return `${size} bytes`;
        if (size / 1024 < 1024) return `${(size / 1024).toFixed(0)} KB`;
        if (size / Math.pow(1024, 2) < 1024) return `${(size / Math.pow(1024, 2)).toFixed(1)} MB`;
        if (size / Math.pow(1024, 3) < 1024) return `${(size / Math.pow(1024, 3)).toFixed(1)} GB`;
        return 'HUGE';
    };

    const onTimeUpdate = () => {
        dispatch(setVideoTime(player.current.currentTime));
    };

    const url = assetLink(file);

    if (file.video) {
        return (
            <div>
                <video
                    ref={player}
                    onCanPlay={() => onLoaded?.()}
                    onTimeUpdate={onTimeUpdate}
                    className="video-player"
                    preload="metadata"
                    controls
                >
                    <source src={url} />
                    Your browser doesn&apos;t support HTML5 video
                </video>
            </div>
        );
    }

    return (
        <div>
            <i className={`fa fa-${fileIcon(extension(file))} mr10`} />
            <button data-testid="button-file" className="btn-link" onClick={() => open()}>
                {file.name}
            </button>{' '}
            - {fileSize(file.size)}
        </div>
    );
};

export default FileLink;
